export const USER_TAGS_KEY = "get-user-tags";

export const tagsQueryKeys = {
  getUserTags: (hash: string) => [USER_TAGS_KEY, hash],
  getSystemTags: (hash: string) => ["get-system-tags", hash],
  getAllTags: ["get-all-tags"]
};
